<script setup>
import { computed } from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import {isCustomColor} from "../../../helpers/common";
import EditableTextField from "../portal-editable-fields/EditableTextField.vue";
import PartneroBranding from "../PartneroBranding.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const isLeadsPage = computed(() => {
    return route().current('partners.leads.show');
});

const showFooter = computed(() => {
    return portalContentAndDesignStore?.getLandingPageSettings?.landing_page_resources?.general?.show_footer ?? false;
});

const layoutBackground = computed(() => {
    if (portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === "one") {
        return "";
    } else if (portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === "two" || portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === "three") {
        return portalContentAndDesignStore.getPageContentBackgroundColorClass;
    }
    return "";
});

const layoutCorners = computed(() => {
    return portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === "one"
        ? "rounded" : portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners !== "none"
            ? portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners
            : "";
});

const layoutStyle = computed(() => {
    if (portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout !== "two") return "";
    const style = portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_style;
    if (style === "shadow") return "shadow-[0_0_16px_rgba(0,0,0,0.08)]";
    if (style === "border") return "border";
    return "";
});
</script>

<template>
    <div
        v-if="portalContentAndDesignStore.portalInitialized"
        class="flex min-h-screen px-4 sm:px-6 lg:px-8"
    >
        <!-- Content width -->
        <div class="mx-auto my-auto w-full max-w-5xl py-12 relative">
            <!-- Main content -->
            <div
                :class="[
                  layoutBackground,
                  layoutCorners,
                  layoutStyle,
                ]"
            >
                <!-- Content -->
                <slot name="content"></slot>
                <!-- /Content -->
            </div>

            <template v-if="!isLeadsPage">
                <template v-if="showFooter">
                    <!-- Footer -->
                    <div
                        :class="[
                              'flex flex-col items-center justify-center gap-4 px-14 py-14 overflow-hidden',
                              isCustomColor(portalContentAndDesignStore.portalLayoutSettings.portal_layout_brand_primary_color) ? 'bg-brand-bg' : `bg-${portalContentAndDesignStore.portalLayoutSettings.portal_layout_brand_primary_color}`,
                              portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === 'one' ? 'rounded' : '',
                              portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === 'two' ? 'mt-6' : '',
                              portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners !== 'none' ? portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners : '',
                            ]"
                        >
                        <editable-text-field
                            text-type="h2"
                            v-model="portalContentAndDesignStore.translationSettings.portal_translation_program_ready_to_start"
                            class="text-white"
                        ></editable-text-field>

                        <editable-text-field
                            text-type="a"
                            v-model="portalContentAndDesignStore.translationSettings.portal_translation_program_page_join_now"
                            href="/register"
                            custom-classes="flex-none inline-block bg-white px-4 py-3.5 font-medium transition ease-in-out hover:bg-white text-black"
                            :class="[portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === 'one' ? 'rounded' : portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners]"
                        ></editable-text-field>

                        <div class="flex space-x-1.5">
                            <editable-text-field
                                class="opacity-60 text-white text-sm inline-block"
                                text-type="span"
                                v-model="portalContentAndDesignStore.translationSettings.portal_translation_program_already_have_an_account"
                            ></editable-text-field>

                            <editable-text-field
                                class="inline-block font-medium opacity-60 text-white text-sm"
                                v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_login"
                                text-type="a"
                                href="/login"
                            ></editable-text-field>
                        </div>

                    </div>
                    <!-- /Footer -->
                </template>
            </template>

            <partnero-branding
                :portal-general-partnero-branding-enabled="portalContentAndDesignStore.partneroBrandingSettings?.enabled ?? false"
                :unique-key-link="portalContentAndDesignStore.partneroBrandingSettings?.unique_key_link ?? ''"
            />
        </div>
    </div>
</template>
